/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Sub_Overview_Credits_Prorated_NoteInputs */



/**
* | output |
* | --- |
* | "Credits are added prorated to the days remaining in the current billing period." |
*
* @param {Sub_Overview_Credits_Prorated_NoteInputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
export const sub_overview_credits_prorated_note = /** @type {((inputs?: Sub_Overview_Credits_Prorated_NoteInputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Sub_Overview_Credits_Prorated_NoteInputs, { locale?: "en" | "de" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "de") return /** @type {LocalizedString} */ ("Guthaben wird anteilig auf die im aktuellen Abrechnungszeitraum verbleibenden Tage gutgeschrieben.")
	return /** @type {LocalizedString} */ ("Credits are added prorated to the days remaining in the current billing period.")
});